export default __webpack_public_path__ + "media/images/wedding-party-4ff9c8ad50de2a8a439ef56b65cda2ca.png";